import { useMemo } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';
// import { CDTextField } from './CDTextField';
import { TextFieldProps } from '@mui/material';

export type CDMonthDatePickerProps = {
    value: Dayjs | Date | string;
    minDate?: Dayjs | Date | string | undefined;
    maxDate?: Dayjs | Date | string | undefined;
    onChange: (newDate: Dayjs | null) => void;
    required?: TextFieldProps['required'];
    variant?: TextFieldProps['variant'];
    size?: TextFieldProps['size'];
    sx?: TextFieldProps['sx'];
} & Omit<DatePickerProps<Dayjs, true>, 'renderInput' | 'value' | 'minDate' | 'maxDate'>;

const CDMonthDatePicker = (props: CDMonthDatePickerProps) => {
    const {
        value: defaultValue,
        minDate: defaultMinDate,
        maxDate: defaultMaxDate,

        required: textFieldRequired = false,
        variant: textFieldVariant = 'outlined',
        size: textFieldSize = 'small',
        sx: textFieldSx = {},
        ...datePickerProps
    } = props;

    const value = useMemo((): Dayjs => {
        return dayjs(defaultValue);
    }, [defaultValue]);

    const minDate = useMemo((): Dayjs | undefined => {
        if (defaultMinDate) {
            return dayjs(defaultMinDate);
        }

        return undefined;
    }, [defaultMinDate]);

    const maxDate = useMemo((): Dayjs | undefined => {
        if (defaultMaxDate) {
            return dayjs(defaultMaxDate);
        }

        return undefined;
    }, [defaultMaxDate]);

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                label="Month"
                {...datePickerProps}
                value={value}
                minDate={minDate}
                maxDate={maxDate}
                views={['year', 'month']}
                onChange={(newValue) => props.onChange(newValue)}
                openTo="month"
                slotProps={{
                    textField: { size: textFieldSize, fullWidth: true },
                }}
                sx={{
                    '& .MuiMonthPicker-root': {
                        margin: (theme: any) => theme.spacing(2),
                        width: 'auto',
                    },
                }}
            />
        </LocalizationProvider>
    );
};

export default CDMonthDatePicker;
